import { useMemo } from "react";
import { useBulkWeeklyHoursQuery } from "utils/wemble-api";
import { PublicUserDto } from "utils/wemble-api.generated";
import UtilizationTable from "./UtilizationTable";
import WorkloadScale from "../shared/WorkloadScale";
import ReactLoading from 'react-loading';
import { makeStyles } from "@material-ui/core";


const useStyles = makeStyles(() => ({
  loader: {
    fill: '#59abcb',
    margin: 'auto',
    marginTop: 50,
    marginBottom: 50,
    width: '10%',
  },
  pageContainer: {
    paddingBottom: 85,
  }
}));

const UtilizationPage = ({
  filteredUsers,
  searchTerm = '',
}: {
  filteredUsers?: PublicUserDto[];
  searchTerm?: string;
}) => {
  const classes = useStyles();
  const userIds = useMemo(() => filteredUsers?.map(u => u._id).filter(Boolean) as string[] || [], [filteredUsers]);
  const { data: utilizationData, isLoading } = useBulkWeeklyHoursQuery({ userIds, weeks: 4 }, { skip: !userIds.length, refetchOnMountOrArgChange: 60 });

  const filteredData = useMemo(() => {
    if (!searchTerm || !utilizationData) return utilizationData;
    const term = searchTerm.toLowerCase();
    return utilizationData.filter(u =>
      u.displayName?.toLowerCase().includes(term) ||
      u.title?.toLowerCase().includes(term)
    );
  }, [utilizationData, searchTerm]);

  return (
    <div className={classes.pageContainer}>
      {filteredData && filteredData.length ? <UtilizationTable filteredUsers={filteredUsers} utilizationData={filteredData} /> : ""}
      {isLoading && <ReactLoading type={'spinningBubbles'} className={classes.loader} />}

      {utilizationData && utilizationData.length > 0 && (
        <WorkloadScale />
      )}
    </div>
  );
};

export default UtilizationPage;
